import React from 'react';
import ReactDOM from 'react-dom';
import { GoabButton, GoabButtonGroup, GoabModal } from '@abgov/react-components';

interface SessionRefreshModalProps {
    isOpen: boolean;
}

export const SessionRefreshModal: React.FC<SessionRefreshModalProps> = ({
    isOpen
}) => {

    // 1. If closed, render nothing.
    if (!isOpen) return null;

    // Define the mandatory action
    const handleRefresh = () => {
        window.location.reload();
    };
    const modalContent = (
        <GoabModal 
            open={true}
            calloutVariant="emergency"
            heading="Session update required"
            actions={
                <GoabButtonGroup alignment="end">
                    <GoabButton leadingIcon="reload" type="primary" onClick={handleRefresh}>
                        Refresh
                    </GoabButton>
                </GoabButtonGroup>
            }
        >
            <p>
                A different account has signed in to the portal in another tab. To keep your information secure, refresh this page to continue with the updated session.
            </p>
        </GoabModal>
    );
    // moving it to document.body, as call is from inside router
    return ReactDOM.createPortal(
        modalContent,
        document.body
    );
};